import { jsx } from "react/jsx-runtime";
import { useClassName } from "@contember/react-utils";
import { dataAttribute } from "@contember/utilities";
import { memo, forwardRef } from "react";
import { ColorInput } from "./ColorInput.js";
import { DateInput } from "./DateInput.js";
import { DateTimeInput } from "./DateTimeInput.js";
import { EmailInput } from "./EmailInput.js";
import { MonthInput } from "./MonthInput.js";
import { PasswordInput } from "./PasswordInput.js";
import { RangeInput } from "./RangeInput.js";
import { SearchInput } from "./SearchInput.js";
import { TelInput } from "./TelInput.js";
import { TimeInput } from "./TimeInput.js";
import { UrlInput } from "./UrlInput.js";
import { WeekInput } from "./WeekInput.js";
import { useTextBasedInput } from "../Hooks/useTextBasedInput.js";
import { toViewClass } from "../../../utils/toViewClass.js";
const InternalTextInput = memo(
  forwardRef(({
    className,
    type,
    focusRing = true,
    withTopToolbar,
    ...outerProps
  }, forwardedRed) => {
    const props = useTextBasedInput({
      ...outerProps,
      className: useClassName("text-input", [
        toViewClass("withTopToolbar", withTopToolbar),
        className
      ])
    }, forwardedRed);
    return /* @__PURE__ */ jsx("input", { "data-focus-ring": dataAttribute(focusRing), ...props, type: "text" });
  })
);
InternalTextInput.displayName = "InternalTextInput";
const TextInput = memo(forwardRef(({ type, ...props }, forwardedRed) => {
  switch (type) {
    case "color":
      return /* @__PURE__ */ jsx(ColorInput, { ref: forwardedRed, ...props });
    case "date":
      return /* @__PURE__ */ jsx(DateInput, { ref: forwardedRed, ...props });
    case "datetime":
    case "datetime-local":
      return /* @__PURE__ */ jsx(DateTimeInput, { ref: forwardedRed, ...props });
    case "email":
      return /* @__PURE__ */ jsx(EmailInput, { ref: forwardedRed, ...props });
    case "month":
      return /* @__PURE__ */ jsx(MonthInput, { ref: forwardedRed, ...props });
    case "password":
      return /* @__PURE__ */ jsx(PasswordInput, { ref: forwardedRed, ...props });
    case "range":
      return /* @__PURE__ */ jsx(RangeInput, { ref: forwardedRed, ...props });
    case "search":
      return /* @__PURE__ */ jsx(SearchInput, { ref: forwardedRed, ...props });
    case "tel":
      return /* @__PURE__ */ jsx(TelInput, { ref: forwardedRed, ...props });
    case "time":
      return /* @__PURE__ */ jsx(TimeInput, { ref: forwardedRed, ...props });
    case "url":
      return /* @__PURE__ */ jsx(UrlInput, { ref: forwardedRed, ...props });
    case "week":
      return /* @__PURE__ */ jsx(WeekInput, { ref: forwardedRed, ...props });
  }
  return /* @__PURE__ */ jsx(InternalTextInput, { ref: forwardedRed, ...props });
}));
TextInput.displayName = "TextInput";
export {
  InternalTextInput,
  TextInput
};
//# sourceMappingURL=TextInput.js.map
